module.exports = __webpack_public_path__ + "static/media/71ZZud1ZecL._SL1500_.db44224d.jpg";